module.exports = __webpack_public_path__ + "static/helpscout1-2e908b6ac831a6e380b2ea33d0500070.png";